import { Typography } from "@mui/material";
import { SubscriptionType } from "schemas/dashboard";
import { SubscriptionMessages } from "schemas/payments";

import { formatEpochTimestamp } from "utils/time";

import styles from "../styles";

interface Props {
  status: SubscriptionType;
  cancelAt?: number;
  warningText?: string;
}
const SubscriptionStatusText = ({
  status,
  cancelAt,
  warningText = "",
}: Props) => {
  return (
    <Typography paragraph sx={styles.warningText}>
      <i>
        {status &&
          status in SubscriptionMessages &&
          SubscriptionMessages[status]}
        {cancelAt &&
          ` Your subscription is set to cancel on ${formatEpochTimestamp({
            epochTimestamp: cancelAt,
            addYear: true,
          })}. ${warningText}`}
      </i>
    </Typography>
  );
};

export default SubscriptionStatusText;
